import React from 'react';
import './e-input.scss';

const Input = (props) => {
  let {value, name, required, onChange} = props;
  let isValid = props.isValid;
  const baseClassname = 'e-input';
  let inputClass = (isValid === true || isValid === null) ? baseClassname : `${baseClassname} ${baseClassname}_not-valid`;


  return (
      <input
        value={value}
        className={inputClass}
        id={name}
        required={required}
        name={name}
        onChange={onChange}
        type="text"
      />
  );
};

export default Input;
